import type { BadgeVariant } from '../../components/ui/Badge';
import type { KhoaDich } from '../../i18n';
import type { HanDung } from './nghiep-vu/khoa-api';
import type { ApiKeyStatus } from './types';

type TongTrangThai = Extract<BadgeVariant, 'success' | 'warning' | 'danger' | 'primary' | 'neutral'>;

/**
 * Trạng thái khoá — nhóm biến thể **trạng thái** của `Badge`. `ACTIVE` là đang
 * phục vụ (`success`); `EXPIRED` là việc quản trị còn dở, cần tạo khoá mới
 * (`warning`); `REVOKED` đã đóng hẳn, không còn gì để làm (`neutral`).
 */
export const BADGE_TRANG_THAI: Record<ApiKeyStatus, { variant: TongTrangThai; khoa: KhoaDich }> = {
  ACTIVE: { variant: 'success', khoa: 'khoaApi.ttHoatDong' },
  EXPIRED: { variant: 'warning', khoa: 'khoaApi.ttHetHan' },
  REVOKED: { variant: 'neutral', khoa: 'khoaApi.ttDaThuHoi' },
};

/** Module trong cột Quyền — nhóm **phân loại**, một tông chung như màn vai trò. */
export const TONG_MODULE: Extract<BadgeVariant, 'violet' | 'teal' | 'orange' | 'info'> = 'info';

/** Số nhãn module hiện trong một ô trước khi gộp thành `+n`. */
export const SO_MODULE_HIEN = 3;

/** Cỡ trang khi nối hết danh sách khoá: tổ chức có tối đa vài chục khoá còn hiệu lực. */
export const MOT_TRANG = 100;

/** Các lựa chọn hạn dùng ở hộp tạo; mặc định 90 ngày. Backend nhận tối đa 730 ngày (ADR-0068 mục 3). */
export const LUA_CHON_HAN: ReadonlyArray<{ gia: HanDung; khoa: KhoaDich }> = [
  { gia: 30, khoa: 'khoaApi.han30' },
  { gia: 90, khoa: 'khoaApi.han90' },
  { gia: 180, khoa: 'khoaApi.han180' },
  { gia: 365, khoa: 'khoaApi.han365' },
  { gia: 'khong', khoa: 'khoaApi.hanKhong' },
];

export const HAN_MAC_DINH: HanDung = 90;

/** Thời gian giữ trạng thái "Đã chép" trên nút. */
export const GIU_DA_CHEP_MS = 2000;
